import styled from 'styled-components';

const SmallDot = () => {
  return <SmallDotStyle>•</SmallDotStyle>;
};

export default SmallDot;

const SmallDotStyle = styled.div`
  padding: 0 3px;
`;
